import { makeStyles } from '@lifeomic/chroma-react/styles';
import { PlotContainer } from '@lifeomic/phc-web-toolkit/src/components/Plot/PlotContainer';
import * as React from 'react';
import Plot from 'react-plotly.js';
import { Layout } from 'plotly.js';
import { defineMessages, useIntl } from 'react-intl';

// We set a static height for the plot so that rendering inside of an
// ExpansionPanel component doesn't cause issues.
const plotHeight = 400;

const messages = defineMessages({
  noData: {
    id: 'pages.summary.stackedBarChart.noData',
    defaultMessage: 'No results',
  },
});

const useStyles = makeStyles(() => ({
  root: {
    height: plotHeight,
  },
  plot: {
    width: '100%',
    height: '100%',
  },
}));

export const StackedBarChart = ({
  // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
  isLoading,
  // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
  chartTitle,
  // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
  xtitle,
  // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
  ytitle,
  // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
  data,
}) => {
  const classes = useStyles({});
  const { formatMessage } = useIntl();

  const hasData = data && data.length > 0;

  const layout: Partial<Layout> = {
    title: chartTitle,
    hovermode: 'x unified' as any,
    autosize: true,
    barmode: 'stack',
    yaxis: {
      title: `<b>${ytitle}</b>`,
      titlefont: {
        family: '"Lato", Helvetica, Roboto, Arial, "Lucida Grande", sans-serif',
      },
    },
    xaxis: {
      automargin: true,
      title: `<b>${xtitle}</b>`,
      titlefont: {
        family: '"Lato", Helvetica, Roboto, Arial, "Lucida Grande", sans-serif',
      },
    },
  };

  const noDataLayout: Partial<Layout> = {
    title: chartTitle,
    xaxis: {
      visible: false,
    },
    yaxis: {
      visible: false,
    },
    annotations: [
      {
        text: formatMessage(messages.noData),
        xref: 'paper',
        yref: 'paper',
        showarrow: false,
        font: {
          size: 28,
        },
      },
    ],
  };

  return (
    <PlotContainer className={classes.root} isLoading={isLoading}>
      <Plot
        className={classes.plot}
        data={data}
        layout={hasData ? layout : noDataLayout}
        useResizeHandler
      />
    </PlotContainer>
  );
};

export default StackedBarChart;
